import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";

import ContainerLandpage from "containers/Landpage";
import {
  PageRoot,
  TopBanner,
  TopBannerBackdrop,
  TopBannerInner,
  TopBannerEyebrow,
  TopBannerTitle,
  TopBannerText,
  SectionContainer,
  SectionBlock,
  SectionEyebrow,
  SectionTitle,
  SectionText,
  StepsGrid,
  StepCard,
  StepNumber,
  StepTitle,
  StepText,
  RankingSection,
  RankingGrid,
  RankingCard,
  RankingPosition,
  RankingInfo,
  RankingTitle,
  RankingMeta,
  TreatmentsSection,
  TreatmentsGrid,
  TreatmentCard,
  TreatmentName,
  TreatmentDescription,
  TreatmentButton,
  OfferSection,
  OfferCard,
  OfferLead,
  OfferTitle,
  OfferText,
  OfferButton,
  LocationSection,
  LocationCard,
  LocationInfo,
  LocationLead,
  LocationTitle,
  LocationAddress,
  LocationAction,
  LocationMap,
  LocationMapFrame,
  LocationFootnote,
  AboutSection,
  AboutPhoto,
  AboutBody,
  AboutName,
  AboutParagraph,
  HighlightsGrid,
  HighlightCard,
  HighlightValue,
  HighlightLabel,
  FeedbackSection,
  FeedbackHeader,
  FeedbackGrid,
  FeedbackActionWrap,
  FeedbackActionButton,
  FeedbackCard,
  FeedbackStars,
  FeedbackQuote,
  FeedbackAuthor,
  FeedbackMeta,
} from "./styled";
import { treatmentsCatalog } from "./treatments-data";

const categories = [
  {
    title: "Harmonizacao facial",
    text: "Protocolos para contorno, proporcao e equilibrio facial com foco em resultado natural.",
    image: "/images/woman-using-face-roller-skincare.jpg",
  },
  {
    title: "Rejuvenescimento",
    text: "Tratamentos para suavizacao de linhas, melhora de firmeza e recuperacao de vitalidade da pele.",
    image: "/images/reju.jpg",
  },
  {
    title: "Estetica corporal",
    text: "Cuidados para reduzir inchaço, melhorar textura da pele e promover conforto no dia a dia.",
    image: "/images/corporal.jpg",
  },
  {
    title: "Terapias integrativas",
    text: "Abordagens combinadas para relaxamento, bem-estar e suporte completo aos resultados.",
    image: "/images/terapias.JPG",
  },
  {
    title: "Cuidados da pele",
    text: "Estrategias personalizadas para luminosidade, uniformizacao e qualidade global da pele.",
    image: "/images/cuidados.jpg",
  },
  {
    title: "Protocolos personalizados",
    text: "Plano individual com combinacao de tecnicas conforme objetivo, rotina e fase de tratamento.",
    image: "/images/rennova.jpg",
  },
];

const feedbacks = [
  {
    author: "C. V.",
    meta: "Paciente de harmonizacao",
    quote:
      "Resultado muito natural no preenchimento labial. O atendimento foi super cuidadoso e eu me senti segura em todas as etapas.",
  },
  {
    author: "A. M.",
    meta: "Paciente de rejuvenescimento",
    quote:
      "O botox ficou leve e elegante. Recebi orientacoes claras no pos-procedimento e tive acompanhamento de perto.",
  },
  {
    author: "L. R.",
    meta: "Paciente de bioestimuladores",
    quote:
      "Adorei o planejamento individual. Em poucas semanas ja percebi melhora de firmeza e textura da pele.",
  },
  {
    author: "T. P.",
    meta: "Paciente de protocolos corporais",
    quote:
      "A drenagem e a massagem fizeram diferenca na rotina. Atendimento tecnico, humano e muito acolhedor.",
  },
  {
    author: "M. S.",
    meta: "Paciente de jato de plasma",
    quote:
      "Fui atendida com muito carinho e paciencia. O resultado ficou lindo e natural, exatamente como eu sonhava.",
  },
  {
    author: "R. A.",
    meta: "Paciente de cuidados da pele",
    quote:
      "Me senti acolhida desde a primeira conversa. O tratamento trouxe mais confianca e minha pele ficou muito mais bonita.",
  },
  {
    author: "P. N.",
    meta: "Paciente de micropigmentacao",
    quote:
      "Atendimento impecavel, delicado e super profissional. O cuidado em cada detalhe me deixou tranquila o tempo todo.",
  },
  {
    author: "E. F.",
    meta: "Paciente de protocolos personalizados",
    quote:
      "Adorei a experiencia completa. Saio de cada sessao com autoestima renovada e com a certeza de estar em boas maos.",
  },
];

const rankingTreatments = [
  {
    title: "Botox",
    share: 39,
    meta: "Suavizacao leve das linhas de expressao com naturalidade.",
  },
  {
    title: "Bioestimuladores",
    share: 33,
    meta: "Estimulo de colageno para firmeza e sustentacao progressiva.",
  },
  {
    title: "Preenchimento labial",
    share: 30,
    meta: "Contorno e volume equilibrado com efeito natural.",
  },
  {
    title: "Jato de plasma",
    share: 26,
    meta: "Rejuvenescimento pontual para areas com flacidez.",
  },
  {
    title: "Fios de PDO",
    share: 22,
    meta: "Suporte estrutural e melhora gradual do contorno facial.",
  },
  {
    title: "Micropigmentacao labial",
    share: 18,
    meta: "Realce de cor e definicao com acabamento harmonico.",
  },
  {
    title: "Microagulhamento com Exossomos e PDRN",
    share: 16,
    meta: "Reparacao cutanea avancada para textura, viço e qualidade da pele.",
  },
];

const allTreatments = treatmentsCatalog.map(({ slug, name, description }) => ({
  slug,
  name,
  description,
}));

const googleMapsAddress =
  "SHLN Bloco G Lote 09 - Asa Norte, Brasilia - DF, 70770-560, Edificio Biosphere";
const googleMapsEmbedUrl = `https://www.google.com/maps?q=${encodeURIComponent(
  googleMapsAddress
)}&output=embed`;
const googleMapsOpenUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  googleMapsAddress
)}`;

export default function LandpageAesthetics() {
  const rootRef = useRef(null);
  const history = useHistory();
  const openTreatmentDetails = (slug) => {
    history.push(`/estetica/tratamentos/${slug}`);
  };

  useEffect(() => {
    const gsap = window?.gsap;
    const ScrollTrigger = window?.ScrollTrigger;

    if (!gsap) {
      return undefined;
    }

    if (ScrollTrigger) {
      gsap.registerPlugin(ScrollTrigger);
    }

    const ctx = gsap.context(() => {
      const shouldReduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
      const parallaxBackground = rootRef.current?.querySelector("[data-parallax-bg]");

      if (parallaxBackground && ScrollTrigger && !shouldReduceMotion && window.innerWidth > 820) {
        gsap.fromTo(
          parallaxBackground,
          { yPercent: -7, scale: 1.08 },
          {
            yPercent: 7,
            scale: 1.13,
            ease: "none",
            scrollTrigger: {
              trigger: "#banner",
              start: "top top",
              end: "bottom top",
              scrub: true,
            },
          }
        );
      }

      gsap.utils.toArray("[data-reveal]").forEach((item) => {
        gsap.fromTo(
          item,
          { autoAlpha: 0, y: 48 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: "power3.out",
            scrollTrigger: ScrollTrigger
              ? {
                  trigger: item,
                  start: "top 84%",
                }
              : undefined,
          }
        );
      });

      const feedbackCards = gsap.utils.toArray("[data-feedback-card]");
      if (feedbackCards.length) {
        gsap.fromTo(
          feedbackCards,
          { autoAlpha: 0, y: 70, scale: 0.96, filter: "blur(6px)" },
          {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            filter: "blur(0px)",
            duration: 0.95,
            ease: "power3.out",
            stagger: gsap.utils.distribute({
              base: 0,
              amount: 0.85,
              from: "center",
              grid: "auto",
            }),
            scrollTrigger: ScrollTrigger
              ? {
                  trigger: "[data-feedback-grid]",
                  start: "top 82%",
                }
              : undefined,
          }
        );
      }
    }, rootRef);

    return () => ctx.revert();
  }, []);

  return (
    <ContainerLandpage variant="aesthetics">
      <PageRoot ref={rootRef}>
        <TopBanner id="banner" data-reveal>
          <TopBannerBackdrop data-parallax-bg />
          <TopBannerInner>
            <TopBannerEyebrow>Asa Norte, Brasília</TopBannerEyebrow>
            <TopBannerTitle>
              Estetica avancada com resultado natural
            </TopBannerTitle>
            <TopBannerText>
              Harmonizacao facial, rejuvenescimento e tratamentos corporais com
              planejamento individual para valorizar sua beleza com seguranca e
              elegancia.
            </TopBannerText>
          </TopBannerInner>
        </TopBanner>

        <SectionBlock id="homecare" data-reveal>
          <SectionContainer vertical>
            <SectionEyebrow>Categorias principais</SectionEyebrow>
            <SectionTitle>Escolha sua categoria de tratamento</SectionTitle>
            <SectionText>
              Selecao dos principais grupos de procedimentos para facilitar sua
              escolha e direcionar a avaliacao com mais clareza.
            </SectionText>

            <StepsGrid>
              {categories.map((category, index) => (
                <StepCard key={category.title} data-reveal $image={category.image}>
                  <StepNumber>{String(index + 1).padStart(2, "0")}</StepNumber>
                  <StepTitle>{category.title}</StepTitle>
                  <StepText>{category.text}</StepText>
                </StepCard>
              ))}
            </StepsGrid>
          </SectionContainer>
        </SectionBlock>

        <RankingSection id="ranking" data-reveal>
          <SectionContainer vertical>
            <SectionEyebrow>Ranking</SectionEyebrow>
            <SectionTitle>Tratamentos mais procurados</SectionTitle>
            <SectionText>
              Ranking dos procedimentos com maior demanda atual na clinica, considerando os
              perfis mais atendidos em avaliacao estetica.
            </SectionText>

            <RankingGrid>
              {rankingTreatments.map((item, index) => (
                <RankingCard key={item.title} data-reveal>
                  <RankingPosition>{String(index + 1).padStart(2, "0")}</RankingPosition>
                  <RankingInfo>
                    <RankingTitle>{item.title}</RankingTitle>
                    <RankingMeta>
                      {item.share}% de procura • {item.meta}
                    </RankingMeta>
                  </RankingInfo>
                </RankingCard>
              ))}
            </RankingGrid>
          </SectionContainer>
        </RankingSection>

        <TreatmentsSection id="treatments" data-reveal>
          <SectionContainer vertical>
            <SectionEyebrow>Catalogo completo</SectionEyebrow>
            <SectionTitle>Conheca todos os tratamentos</SectionTitle>
            <SectionText>
              Oferecemos tratamentos esteticos pensados para realcar sua beleza, autoestima e
              bem-estar, sempre com atendimento humanizado e protocolos personalizados.
              <br />
              <br />
              E para voce se sentir ainda mais segura, disponibilizamos um album de fotos com
              resultados para conhecer melhor nossos procedimentos.
            </SectionText>

            <TreatmentsGrid>
              {allTreatments.map((item) => (
                <TreatmentCard key={item.name} data-reveal>
                  <TreatmentName>{item.name}</TreatmentName>
                  <TreatmentDescription>{item.description}</TreatmentDescription>
                  <TreatmentButton type="button" onClick={() => openTreatmentDetails(item.slug)}>
                    Acesse o album de fotos
                  </TreatmentButton>
                </TreatmentCard>
              ))}
            </TreatmentsGrid>
          </SectionContainer>
        </TreatmentsSection>

        <AboutSection id="about" data-reveal>
          <SectionContainer>
            <AboutPhoto src="/images/dra-nova.jpg" alt="Profissional de estetica avancada" />
            <AboutBody>
              <SectionEyebrow>Sobre a profissional</SectionEyebrow>
              <AboutName>Dra. Heloisa Andrade</AboutName>
              <AboutParagraph>
                Graduada em Enfermagem com Especializacao em Estetica Avancada, Estomaterapia,
                Cuidados Pos Operatorios, Centro Cirurgico e CME, Graduada em Gestao em Saude
                Publica, com vasta experiencia em Home Care, Cuidados de PO de cirurgia plastica,
                Estetica Corpotal, Facial e Capilar, Centro Cirurgico e CME. Especializada em
                procedimentos de alto padrao, com atuacao voltada a excelencia, seguranca e
                personalizacao no cuidado estetico.
                <br />
                <br />
                Com atendimento humanizado e olhar tecnico apurado, realiza procedimentos em
                consultorio com protocolos modernos e individualizados, sempre priorizando
                resultados naturais, sofisticacao e bem-estar.
                <br />
                <br />
                Alem dos atendimentos em ambiente clinico, tambem oferece servicos em home care,
                proporcionando praticidade, conforto e exclusividade para pacientes que desejam
                receber cuidados especializados no conforto de casa, sem abrir mao da qualidade e
                do padrao profissional.
              </AboutParagraph>

              <HighlightsGrid>
                <HighlightCard>
                  <HighlightValue>DF</HighlightValue>
                  <HighlightLabel>Cobertura em Brasilia e entorno</HighlightLabel>
                </HighlightCard>
                <HighlightCard>
                  <HighlightValue>+6</HighlightValue>
                  <HighlightLabel>Protocolos combinados para facial e corporal</HighlightLabel>
                </HighlightCard>
                <HighlightCard>
                  <HighlightValue>1:1</HighlightValue>
                  <HighlightLabel>Plano exclusivo para cada paciente</HighlightLabel>
                </HighlightCard>
              </HighlightsGrid>
            </AboutBody>
          </SectionContainer>
        </AboutSection>

        <FeedbackSection data-reveal>
          <SectionContainer vertical>
            <FeedbackHeader>
              <SectionEyebrow>Feedback</SectionEyebrow>
              <SectionTitle>O que as pacientes falam dos tratamentos</SectionTitle>
              <SectionText>
                Relatos reais sobre naturalidade dos resultados, seguranca do processo
                e acompanhamento em cada fase do protocolo estetico.
              </SectionText>
            </FeedbackHeader>

            <FeedbackGrid data-feedback-grid>
              {feedbacks.map((feedback) => (
                <FeedbackCard key={`${feedback.author}-${feedback.meta}`} data-feedback-card>
                  <FeedbackStars>★★★★★</FeedbackStars>
                  <FeedbackQuote>{feedback.quote}</FeedbackQuote>
                  <FeedbackAuthor>{feedback.author}</FeedbackAuthor>
                  <FeedbackMeta>{feedback.meta}</FeedbackMeta>
                </FeedbackCard>
              ))}
            </FeedbackGrid>

            <FeedbackActionWrap>
              <FeedbackActionButton
                type="button"
                onClick={() =>
                  window.open(
                    "https://g.page/r/CREu9kLNOackEAE/review",
                    "_blank"
                  )
                }
              >
                Deixe sua avaliacao
              </FeedbackActionButton>
            </FeedbackActionWrap>
          </SectionContainer>
        </FeedbackSection>

        <OfferSection data-reveal>
          <SectionContainer vertical>
            <OfferCard>
              <div>
                <OfferLead>Consulta estrategica</OfferLead>
                <OfferTitle>Receba seu plano estetico personalizado</OfferTitle>
                <OfferText>
                  Envie uma mensagem e receba orientacoes iniciais, sugestoes de protocolo
                  e possibilidades de combinacao de tratamentos para seu objetivo.
                </OfferText>
              </div>
              <OfferButton
                onClick={() =>
                  window.open(
                    "https://wa.me/61998333005?text=Ola%2C%20quero%20agendar%20minha%20avaliacao%20gratuita%20de%20estetica.",
                    "_blank"
                  )
                }
              >
                Agende sua avaliacao gratuita
              </OfferButton>
            </OfferCard>
          </SectionContainer>
        </OfferSection>

        <LocationSection id="location" data-reveal>
          <SectionContainer vertical>
            <LocationCard>
              <LocationInfo>
                <LocationLead>Localizacao</LocationLead>
                <LocationTitle>Nosso espaco em Brasilia</LocationTitle>
                <LocationAddress>
                  Shln Bloco G Lote 09 - Asa Norte, Brasilia - DF, 70770-560, Edificio
                  Biosphere
                </LocationAddress>
                <LocationAction onClick={() => window.open(googleMapsOpenUrl, "_blank")}>
                  Abrir no Google Maps
                </LocationAction>
              </LocationInfo>

              <LocationMap>
                <LocationMapFrame
                  title="Mapa de localizacao - Edificio Biosphere"
                  src={googleMapsEmbedUrl}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </LocationMap>
            </LocationCard>
            <LocationFootnote>
              Atendimento em consultorio mediante a agendamento previo.
            </LocationFootnote>
          </SectionContainer>
        </LocationSection>
      </PageRoot>
    </ContainerLandpage>
  );
}
